class CountryPopup extends HTMLElement {
  constructor() {
    super();

    this.modal = document.querySelector('modal-dialog.country-popup-modal');
    this.wrapper = this;
    this.buttonClose = this.wrapper.querySelector('[id^="ModalClose-"]');
    this.buttonStay = this.wrapper.querySelector('[data-country-message-stay]');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.wrapper) {
      return;
    }

    this.buttonStay.addEventListener('click', this.close.bind(this));
    this.buttonClose.addEventListener('click', this.close.bind(this));

    this.options = JSON.parse(this.wrapper.dataset.countryMessageOptions);
    this.cookieId = 'country_popup';

    // if country popup days is set to zero, remove cookie if exists
    if (parseInt(this.options.expiresInDays) == 0) {
      Cookies.remove(this.cookieId);
    }
    this.countryPopupCookie = Cookies.get(this.cookieId);

    if (!this.mayRenderCountryPopup()) {
      return false;
    }

    // get country location
    this.getLocation();

  };

  mayRenderCountryPopup() {
    // guard: check if popup cookie is set
    if (this.countryPopupCookie) {
      return false;
    }
    // guard: check if there are messages given
    if (this.options.popupMessages.length == 0) {
      return false;
    }

    return true;
  }

  async getLocation() {
    // get country code from cookie
    this.countryCode = Cookies.get(this.cookieId + '-country_code');

    // if country code is given, return the code
    if (this.countryCode) {
      this.renderCountryPopup();
    }

    // get country code from api, if done call the callback
    var countryCode = await this.getCountryCodeFromAPI();
    await this.setCountryCode(countryCode);
    this.renderCountryPopup();
  }

  async getCountryCodeFromAPI() {
    var defaultApiUrl = '//extreme-ip-lookup.com/json/';
    var countryCodeApi = this.options.locationApiUrl || defaultApiUrl;
    var countryCodeFieldnameId = this.options.locationFieldName || 'country_code';

    var res = await fetch(countryCodeApi);
    var data = await res.json();
    if (data[countryCodeFieldnameId]) {
      return data[countryCodeFieldnameId];
    }
  }

  async setCountryCode(countryCode) {
    // guard: check country code is given
    if (!countryCode) {
      return '';
    }

    // set the country code
    this.countryCode = countryCode;

    // create a cookie with the country code
    var inOneHourMinutes = new Date(new Date().getTime() + 60 * 1000);
    Cookies.set(this.cookieId + '-country_code', countryCode, {
      expires: inOneHourMinutes
    });
  }

  renderCountryPopup() {
    // check country code is given
    if (this.countryCode == '' || this.options.currentCountryCode == '') {
      return;
    }
    // guard: if the given country_Code is the same as the shop country code then skip!
    if (this.countryCode == this.options.currentCountryCode) {
      return;
    }

    var countryData;
    // get the data by country code if available
    if (this.options.popupMessages[this.countryCode]) {
      countryData = this.options.popupMessages[this.countryCode];

      // if country option does not exists shop ROW
    } else if (this.options.popupMessages['ROW']) {
      countryData = this.options.popupMessages['ROW'];

      // guard: no country data to render
    } else {
      return;
    }

    // populate the wrapper with the country data
    this.querySelector('[data-country-message-title]').textContent = countryData.country_title;
    this.querySelector('[data-country-message-text]').textContent = countryData.country_body;
    this.querySelector('[data-country-message-url]').setAttribute('href', countryData.country_url);
    this.querySelector('[data-country-message-label]').textContent = countryData.country_button;
    this.querySelector('[data-country-message-stay]').textContent = countryData.country_stay;

    this.open();

    // set enable cookie
    Cookies.set(this.cookieId, true, {
      expires: this.options.expiresInDays
    });
  }

  open() {
    this.modal.classList.add('animate', 'active');
    this.modal.addEventListener('transitionend', () => {
      this.modal.focus();
      trapFocus(this.modal);
    }, { once: true });
    this.modal.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    Cookies.set(this.cookieId, false, {
      expires: this.options.expiresInDays
    });
    this.modal.hide()
    this.modal.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.modal);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.modal && !target.closest('country-popup')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
};
customElements.define('country-popup', CountryPopup);
